import { LuCircleCheck } from 'react-icons/lu';
import "./style.css";

const ClientDeliverables = ({ data }) => {
  if (!data?.items?.length) return null;
  return (
    <section className="project-case-card client-deliverables">
      <h2 className="project-case-card__title">{data.title}</h2>

      <ul className="client-deliverables__list">
        {data.items.map((item) => (
          <li className="client-deliverables__item" key={item}>
            <LuCircleCheck />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ClientDeliverables;
